import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { EmojiIcon } from 'components/EmojiIcon'
import {
    gestureTypes,
    gesturesData,
    gesturesMap,
    gestureIds,
} from 'components/Tiles/Student/Gestures'
import {
    emitGestureMsg,
    emitRevertGestureMsg,
    emitTriggerGiphyModal,
} from 'helpers/events'
import { _staticGestures } from 'store/selectors/Gestures'
import { _userInfo, _userType } from 'store/selectors/User'

import { Wrapper, GiphyIconContainer, GiphyImage } from './styles'

let reactionAutoHideTimer = null

const Reactions = () => {
    const staticGestures = useSelector(_staticGestures)
    const userType = useSelector(_userType)
    const userInfo = useSelector(_userInfo)

    useEffect(() => {
        const gesture = Object.values(staticGestures).find(
            el => el.from_user === userInfo.user_id
        )
        let activeValue = false
        if (
            gesture &&
            gesture.gesture_type === gestureTypes.static &&
            gesture.gesture === gesturesMap.raiseHand
        ) {
            activeValue = true
        }
        setReactionData({
            reactionId: activeValue
                ? gestureIds.raised_hand_with_fingers_splayed
                : '',
            isActive: activeValue,
        })
    }, [staticGestures, userInfo.user_id])

    const [reactionData, setReactionData] = React.useState({
        reactionId: '',
        isActive: false,
    })

    React.useEffect(() => {
        return () => {
            if (reactionAutoHideTimer) {
                clearTimeout(reactionAutoHideTimer)
            }
        }
    }, [])

    const onReactionClick = React.useCallback(
        id => {
            const gesture = gesturesData.find(item => item.id === id)
            const isGestureAutoReversible = !(gesture.autoRevert === false)

            if (
                reactionData.isActive &&
                id === reactionData.reactionId &&
                isGestureAutoReversible
            )
                return

            if (reactionData.isActive) {
                setReactionData({
                    reactionId: id,
                    isActive: false,
                })

                const storedGesture = Object.values(staticGestures).find(
                    item =>
                        item.from_user === userInfo.user_id &&
                        item.gesture === gesture.gestureKey
                )

                if (storedGesture) {
                    emitRevertGestureMsg({
                        gesturePK: storedGesture.gesture_pk,
                    })
                }
            } else {
                setReactionData({
                    reactionId: id,
                    isActive: true,
                })

                emitGestureMsg({
                    gestureKey: gesture.gestureKey,
                    autoHide: isGestureAutoReversible,
                    ...(!isGestureAutoReversible
                        ? {
                              gestureType: gestureTypes.static,
                          }
                        : null),
                })

                if (isGestureAutoReversible) {
                    // set a timer to revert gesture
                    reactionAutoHideTimer = setTimeout(() => {
                        setReactionData(state => {
                            return {
                                ...state,
                                isActive: false,
                            }
                        })
                    }, 3000)
                }
            }
        },
        [reactionData, userInfo, staticGestures]
    )

    const { isActive, reactionId } = reactionData

    return (
        <Wrapper>
            {gesturesData.map(gesture => {
                const { id, gestureKey, available } = gesture

                if (!available.includes(userType)) return null

                return (
                    <EmojiIcon
                        key={gestureKey}
                        isActive={
                            isActive &&
                            reactionId === id &&
                            gesture.autoRevert === false
                        }
                        emoji={{ id }}
                        onClick={() => onReactionClick(id)}
                        disabled={isActive && reactionId !== id}
                    />
                )
            })}

            <GiphyIconContainer onClick={() => emitTriggerGiphyModal(true)}>
                <GiphyImage src="/assets/revamp/giphy.svg" alt="giphy-icon" />
            </GiphyIconContainer>
        </Wrapper>
    )
}

export { Reactions }
